<template>
    <span :class="classList">
        <i :class="icon"></i>
    </span>
</template>

<script>
export default {
    props: ['classes', 'icon'],

    computed: {
        classList() {
            return 'icon '+ this.classes;
        }
    }

}
</script>
